import { setConfig } from '@plug-core/appConfig'

setConfig('fetchEnv', (key) => import.meta.env[`VITE_${key}`])
